import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

const BANNER_MIN_HEIGHT = 130;
const GRAPHIC_SLOT_SIZE = 98;
// The pre-composed asset has internal whitespace around the photos, and in Figma
// the photos overflow the 98px graphic frame. Render it larger than the slot and
// let it overflow (the banner clips with overflow: 'hidden').
const GRAPHIC_OVERFLOW_SIZE = 230;
// Figma pill vertical padding is 6px; no exact spacing token (spacing[2]=4, spacing[3]=8).
const PILL_VERTICAL_PADDING = 6;

export const styles = StyleSheet.create((colors) => ({
  banner: {
    width: '100%',
    minHeight: BANNER_MIN_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[7],
    padding: theme.spacing[5],
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.backgroundInverseStatic,
    overflow: 'hidden',
  },
  pressed: {
    opacity: 0.85,
  },
  copy: {
    flex: 1,
    gap: theme.spacing[3],
    justifyContent: 'center',
  },
  pill: {
    alignSelf: 'flex-start',
    paddingHorizontal: theme.spacing[4],
    paddingVertical: PILL_VERTICAL_PADDING,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundL1Inverse,
  },
  pillText: {
    textTransform: 'uppercase',
  },
  graphicSlot: {
    width: GRAPHIC_SLOT_SIZE,
    height: GRAPHIC_SLOT_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  graphic: {
    // Larger than the slot; the slot centers it so the photos read at Figma size
    // and overflow the slot bounds equally. The banner clips the excess.
    width: GRAPHIC_OVERFLOW_SIZE,
    height: GRAPHIC_OVERFLOW_SIZE,
  },
}));
